export default {"src":"https://static.upbound.io/_next/static/media/dev-favicon.585384f1.ico","height":48,"width":48,"blurWidth":0,"blurHeight":0};